import {
    IconButton,
    ListItemIcon,
    ListItemText,
    MenuItem,
} from '@mui/material';
import * as MaterialUIIcons from '../../controls/MaterialUIIcons';
interface MultiSelectCtxMenuProps {
    select?: () => void;
    unSelect: () => void;
    ctxMenu?: Element;
}

interface TreeMultiSelectCtxMenuProps extends MultiSelectCtxMenuProps {
    selectAllChildren?: () => void;
    unSelectAllChildren: () => void;
}

export const MultiSelectCtxMenu = ({
    select,
    unSelect,
    ctxMenu,
}: MultiSelectCtxMenuProps) => {
    return (
        <>
            <MenuItem onClick={select}>
                <ListItemIcon>
                    <IconButton color="primary">
                        <MaterialUIIcons.CheckIcon fontSize="small" />
                    </IconButton>
                </ListItemIcon>
                <ListItemText primary="Velg markerte linjer" />
            </MenuItem>
            <MenuItem onClick={unSelect}>
                <ListItemIcon>
                    <IconButton color="primary">
                        <MaterialUIIcons.RemoveIcon fontSize="small" />
                    </IconButton>
                </ListItemIcon>
                <ListItemText primary="Fjern valg på markerte linjer" />
            </MenuItem>
            {ctxMenu}
        </>
    );
};

export const TreeMultiSelectCtxMenu = ({
    select,
    unSelect,
    selectAllChildren,
    unSelectAllChildren,
}: TreeMultiSelectCtxMenuProps) => {
    return (
        <>
            <MenuItem onClick={selectAllChildren}>
                <ListItemIcon>
                    <IconButton color="primary">
                        <MaterialUIIcons.CheckIcon fontSize="small" />
                    </IconButton>
                </ListItemIcon>
                <ListItemText primary="Velg denne og underliggende" />
            </MenuItem>
            <MenuItem onClick={unSelectAllChildren}>
                <ListItemIcon>
                    <IconButton color="primary">
                        <MaterialUIIcons.RemoveIcon fontSize="small" />
                    </IconButton>
                </ListItemIcon>
                <ListItemText primary="Fjern valg for denne og underliggende" />
            </MenuItem>
            <MultiSelectCtxMenu select={select} unSelect={unSelect} />
        </>
    );
};
